import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Table,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import { FieldArray } from "formik";
import { TablesWithoutBorders } from "../../pages/Tables/BasicTables/BasicTablesCode";
import { Link } from "react-router-dom";
import InputField from "../Utils/InputField";
import { LabelText } from "../Utils/Input";
import { useSelector } from "react-redux";

export default function Attribute({
  values,
  touched,
  errors,
  handleChange,
  setTouched,
  handleChangeForAttributeValue,
  isEmptyOrInvalidField,
  deviceID,
  isEdit,
}) {
  const fetchDeviceData = useSelector((state) => state.fetchDevice.fetchDevice)
  useEffect(() => {
    values.attributeList = fetchDeviceData?.attributeList || [];
  }, [fetchDeviceData]);
  return (
    <FieldArray name="attributeList">
      {({ push, remove, replace }) => {
        if (values?.attributeList?.length === 0) {
          push({ name: "", value: "" });
        }
        return (
          <Row className="mt-4">
            <Col lg={12}>
              <div className=" mb-3">
                <h4 className="card-title mb-3">Attributes</h4>
              </div>
              <Row className="gy-4 mb-3 align-items-end border-bottom">
                <Col xxl={3} md={6} lg={3} className="pe-0">
                  <LabelText
                    htmlFor={`attributesname`}
                    classLabelName={"ms-0 rv-form-label"}
                    displayText="Name"
                    className="text-danger"
                    important={"*"}
                  />
                </Col>
                <Col xxl={3} md={6} lg={3} className="pe-0">
                  <LabelText
                    htmlFor={`attributesvalue`}
                    classLabelName={"ms-0 rv-form-label"}
                    displayText="Value"
                    className="text-danger"
                    important={"*"}
                  />
                </Col>
              </Row>

              {values?.attributeList &&
                values?.attributeList?.length > 0 &&
                values?.attributeList?.map((attribute, index) => {
                  return (
                    <Row key={index} className="gy-4 mb-2 align-items-end">
                      <Col xxl={3} md={6} lg={3} className="pe-0">
                        <FormGroup>
                          <InputField
                            name={`attributeList[${index}].name`}
                            className={
                              (touched.attributeList &&
                                touched.attributeList[index] &&
                                !values.attributeList[index].name) ||
                                false
                                ? "is-invalid"
                                : ""
                            }
                            disabled={deviceID[index] && isEdit ? true : false}
                            placeholder="Enter Name"
                            type="text"
                            handleChange={handleChangeForAttributeValue(
                              handleChange
                            )}
                            value={values.attributeList[index].name || ""}
                            invalid={
                              errors.attributeList &&
                                errors.attributeList[index] &&
                                touched.attributeList &&
                                touched.attributeList[index] &&
                                touched.attributeList[index].value
                                ? true
                                : false
                            }
                          />
                          {/* <SelectField
                            name={`attributes[${index}].name`}
                            options={attributeNameOptions}
                            handleChange={(selectedOption) =>
                              handleAttributeChange(index, 'name', selectedOption, setFieldValue, values)
                            }
                            value={attribute.name || ''}
                            placeholder="Select Attribute Name"
                            isRVStyle={true}
                            className={attribute?.value && !attribute?.name ? "error-input" : ""}
                          /> */}
                        </FormGroup>
                      </Col>
                      <Col xxl={3} md={6} lg={3} className="pe-0">
                        <FormGroup>
                          <InputField
                            name={`attributeList[${index}].value`}
                            className={
                              (touched.attributeList &&
                                touched.attributeList[index] &&
                                !values.attributeList[index].value) ||
                                false
                                ? "is-invalid"
                                : ""
                            }
                            disabled={deviceID[index] && isEdit ? true : false}
                            placeholder="Enter Value"
                            type="text"
                            handleChange={handleChangeForAttributeValue(
                              handleChange
                            )}
                            value={values.attributeList[index].value || ""}
                            invalid={
                              errors.attributeList &&
                                errors.attributeList[index] &&
                                touched.attributeList &&
                                touched.attributeList[index] &&
                                touched.attributeList[index].value
                                ? true
                                : false
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xxl={2}
                        md={3}
                        lg={2}
                        className="d-flex justify-content-start align-self-center"
                      >
                        {index === 0 ? (
                          <>
                            <i
                              className="ri-add-circle-line text-primary fs-4"
                              style={{ cursor: "pointer", marginTop: "-12px" }}
                              onClick={() => {
                                const lastIndex =
                                  values.attributeList.length - 1;
                                if (
                                  lastIndex === -1 ||
                                  !isEmptyOrInvalidField(lastIndex, values)
                                ) {
                                  push({ name: "", value: "" });
                                  setTouched({
                                    ...touched,
                                    attributeList: {
                                      ...touched.attributeList,
                                      [lastIndex]: {
                                        name: false,
                                        value: false,
                                      },
                                    },
                                  });
                                }
                              }}
                              title="Add Attribute"
                            />
                            <i
                              className="ri-eraser-line text-danger fs-4 ms-3"
                              style={{ cursor: "pointer", marginTop: "-12px" }}
                              onClick={() =>
                                replace(0, {
                                  name: "",
                                  value: "",
                                })
                              }
                              title="Delete Attribute"
                            />
                          </>
                        ) : (
                          <i
                            className="ri-delete-bin-5-line text-danger fs-4"
                            style={{ cursor: "pointer", marginTop: "-12px" }}
                            onClick={() => remove(index)}
                            title="Delete Attribute"
                          />
                        )}
                      </Col>
                    </Row>
                  );
                })}
            </Col>
          </Row>
        );
      }}
    </FieldArray>
  );
}
